import { Injector, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CountriesService } from '../services/countries.service';

@Pipe({
  name: 'countryName',
  pure: false,
  standalone: true,
})
export class CountryNamePipe implements PipeTransform {
  constructor(private translate: TranslateService, private countriesService: CountriesService, private injector: Injector) {}

  transform(countryCode: string): string {
    const userLang = this.translate.currentLang as 'ru' | 'en';
    const countryData = this.countriesService.countriesData;

    if (!countryData) {
      return '';
    }

    const country = countryData[countryCode];

    if (!country || !country[userLang]) {
      return countryCode;
    }

    return country[userLang];
  }
}
